import { useEffect, useState } from 'react';
import Modal from '../../components/Modal/Modal';
import Button from '../../components/Button/Button';
import { cookieItems } from '../../data/data';
import { ClassNameProps } from '../../types/types';

const CookiePopup: React.FC<ClassNameProps> = ({ className }) => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const cookiecook = getCookie('cookiecook');
    // if (cookiecook !== 'no') {
    //   setShowPopup(true);
    //   }
    if (cookiecook !== 'yes') {
      setShowPopup(true);
    }
  }, []);

  const handlePopupClose = () => {
    setShowPopup(false);
    let date = new Date();
    //   date.setDate(date.getDate() + 30);
    date.setDate(date.getDate() - 1);
    document.cookie = `cookiecook=no; path=/; expires=${date.toUTCString()}`;
  };

  const getCookie = (name: string) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(';').shift();
  };

  return (
    <Modal showPopup={showPopup} onClose={handlePopupClose} className='cookie'>
      <div className={`${className}__inner`}>
        {cookieItems.map((item) => (
          <span key={item.id} className={`${className}__text text-normal`}>
            {item.texthref && item.href ? (
              <>
                {item.text}
                <a
                  href={item.href}
                  rel='noopener noreferrer'
                  target='_blank'
                  className='cookie__link'
                >
                  &nbsp;{item.texthref}&nbsp;
                </a>
              </>
            ) : (
              item.text
            )}
          </span>
        ))}
      </div>
      <Button className={`${className}__button`} onClick={handlePopupClose}>
        Allow cookies
      </Button>
    </Modal>
  );
};

export default CookiePopup;
